
<div style="width: 100%; height: 100%; padding-left: 32px; padding-right: 32px; justify-content: flex-start; align-items: center; gap: 8px; display: inline-flex">
    <div data-style="Outlined" style=" position: relative; overflow: hidden">
      <mat-icon class="big-icon">public</mat-icon>
    </div>
    <div data-gutter-bottom="False" data-variant="h6" style="flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
        <div style="align-self: stretch; color: rgba(0, 0, 0, 0.60); font-size: 20px; font-family: Roboto; font-weight: 500; line-height: 32px; letter-spacing: 0.15px; word-wrap: break-word">Payment offices</div>
    </div>
  </div>
  <div class="column">
    <div class="task--search-bar">
        <mat-form-field appearance="outline" class="search--input">
            <mat-label>Type name to find</mat-label>
            <input matInput type="text" placeholder="Type user name to find" [(ngModel)]="query" (ngModelChange)="onSearch()">
            <button matSuffix mat-icon-button>
                <mat-icon>search</mat-icon>
              </button>
          </mat-form-field>
<div class="task--search-bar-items">
      <app-icon-detail [model]="this.userModel"></app-icon-detail>
            <button class="continue" (click)="addNewPaymentOffice()" mat-button> <mat-icon [svgIcon]="icons.YesIcon"></mat-icon>
             ADD OFFICE</button>
</div>
 
      
    </div>
    <div class="mat-elevation-z8">
        <table   mat-table matSort aria-label="Elements">
 
        
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
              <td mat-cell *matCellDef="let row">{{row.name}}</td>
            </ng-container>
      <ng-container matColumnDef="isActive">
    <th  mat-header-cell *matHeaderCellDef>Active</th>
    <td  mat-cell *matCellDef="let row">
 
<mat-checkbox [checked]="row.active" (change)="toggleActive(row, $event.checked)">
</mat-checkbox>
    </td>
      </ng-container>
       
    
    
          
            <ng-container matColumnDef="actions">
              <th style="text-align: right; background-color: #E3E3E3;"  mat-header-cell *matHeaderCellDef>Actions</th>
            
              <td style="text-align: right;" mat-cell *matCellDef="let element;let i=index;">
                   <div style="display: flex; justify-content: flex-end;">

                                    <mat-icon style="text-align: right;color: #C62828; cursor: pointer;" (click)="deletePaymentOffice(element)" aria-label="Delete">delete_outline</mat-icon>
                                      <mat-icon style="text-align: right;color:#2196F3; cursor: pointer;" (click)="editPaymentOffice(element)" aria-label="Edit">edit</mat-icon>  
                   </div>
  </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr  mat-row *matRowDef="let row; columns: displayedColumns;"
          ></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                No data matching the filter.
              </td>
            </tr>
          </table>
          <mat-paginator #paginator [length]="dataSource.data.length" [pageIndex]="0" [pageSize]="10"
          [pageSizeOptions]="[5, 10, 20]" aria-label="Select page">
        </mat-paginator>
    </div>
  </div>